<template>
  <div>
    I would like to add a
    <select v-model="config.type">
      <option value="">Select One</option>
      <option value="DevicesWidget">Devices</option>
      <option value="EnrollmentWidget">Enrollment</option>
      <option value="IncidentsWidget">Incidents</option>
      <option value="MetabaseWidget">Lens Question</option>
    </select>
    card to the page


    <div
      ref="card"
      :is="getConfigCard(config.type)"
      v-model="config"
      />
  </div>
</template>

<script>
  import DefaultConfig from './DefaultConfig.vue'
  import MetabaseConfig from './MetabaseConfig.vue'

  export default {
    components: {
      DefaultConfig,
      MetabaseConfig
    },
    data() {
      return {
        config: {
          type: ""
        }
      }
    },
    methods: {
      getConfigCard: function(newCardType) {
        if (!newCardType) {
          return false;
        }

        switch (newCardType) {
          case 'MetabaseWidget':
            return 'MetabaseConfig';
          default:
            return 'DefaultConfig';
        }
      },
      addCard: function(config) {
        this.$parent.addCard(config);
        this.config = {
          type: ""
        };
      }
    }
  }
</script>

<style scoped>

</style>